<template>
    <header id="header" class="safe-width">
        <div id="header-logo">
            <img @click="toHome" src="../img/logo.svg" />
        </div>
        <cvp-user c="user primary medium"></cvp-user>
    </header>
</template>

<script>
    export default {
        name: "CommonHeader",
        methods: {
            toHome() {
                window.location.href = "index.html";
            }
        }
    }
</script>

<style lang="scss" scoped>
    #header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 30px 0 15px;
        height: 80px;

        #header-logo {
            width: 0;
            flex-shrink: 1;
            flex-grow: 1;

            img {
                padding: 8px;
                width: 152px;
                max-width: 100%;
                cursor: pointer;
            }
        }

        .user {
            max-width: 100%;
            flex-shrink: 0;
        }
    }
</style>
